const HeaderModule = ({ data }) => {
  const layoutClasses = {
    grid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4',
    list: 'space-y-4',
    carousel: 'flex space-x-4 overflow-x-auto'
  };

  // Format summary array into bullet-separated string
  const formatSummary = (summary) => {
    if (!summary || !Array.isArray(summary)) return '';
    return summary.join(' • ');
  };

  return (
      <div className="card my-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div>
            <h1 className="text-3xl font-bold theme-primary">{data.title}</h1>
            <p className="theme-secondary mt-1">
              {data.subtitle}
            </p>
          </div>
          <div className="text-sm theme-secondary mt-2 md:mt-0">
            {formatSummary(data.summary)}
          </div>
        </div>
      </div>)
} 

export default HeaderModule;